import { render, staticRenderFns } from "./DiscountRecurrence.vue?vue&type=template&id=525d7213&"
import script from "./DiscountRecurrence.vue?vue&type=script&lang=ts&"
export * from "./DiscountRecurrence.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports